import tw, { styled } from "twin.macro";

export const BannerWrapper = styled.div(({ isPair }) => [
  `@media screen and (min-width: 768px) { max-width: 768px; }`,
  `@media screen and (min-width: 1024px) { max-width: 1024px; }`,
  `@media screen and (max-width: 768px) { text-align: center }`,
  isPair ? tw`lg:flex lg:gap-6` : ``,
  tw`lg:mt-6 mx-auto`
]);
